import React from 'react'
import type { CSSProperties, PropsWithChildren } from 'react'
import Badge from 'antd/lib/badge'
import { omit } from 'lodash-es'

import 'antd/lib/badge/style/css'
import './BadgeComponent.scss'

type BadgeComponentProps = PropsWithChildren<{
  color?: string
  style?: CSSProperties
  count?: string | number
}>

const BadgeComponent = (props: BadgeComponentProps) => {
  const { style, color } = props

  const newStyle = {
    ...style,
  }

  if (color) {
    newStyle.backgroundColor = color
    newStyle.boxShadow = `0 0 0 1px ${color}`
  }

  // Antd workaround. They show a dot if status or color is truthy.
  // @see https://github.com/ant-design/ant-design/blob/3.26.20/components/badge/index.tsx#L106
  const badgeProps = omit(props, ['color'])

  return (
    <div className="badge-component antd-component">
      <Badge {...badgeProps} style={newStyle} />
    </div>
  )
}

export default BadgeComponent
